import {
  NewBusinessBasicsReducer,
  NewBusinessContentInfoReducer,
  NewBusinessSocialMediaReducer,
  NewBusinessStatsReducer,
  NewBusinessThemeReducer,
} from "./new-business.reducer";
import { combineReducers } from "redux";

const allReducers = combineReducers({
  BusinessBasicReducer: NewBusinessBasicsReducer,
  BusinessContentReducer: NewBusinessContentInfoReducer,
  BusinessSocailMediaReducer: NewBusinessSocialMediaReducer,
  BusinessStatsReducer: NewBusinessStatsReducer,
  BusinessThemeReducer: NewBusinessThemeReducer,
});

export default allReducers;
